<template>
    <Guest>
        <h1 class="login__title mb-6 text-center lg:text-left">
            {{ $__('login.password_reset_page.title_line_1') }} <br/>
            {{ $__('login.password_reset_page.title_line_2') }}
        </h1>

        <form @submit.prevent="submit" class="-mt-2">
            <InputGroupFull type="text" name="username" v-model="form.email" :error="this.$page.props.errors.email"
                        label="login.password_reset_page.form_username"/>

            <div class="mt-10 w-full">
                <Button :disabled="showLoader" :class="['w-full lg:w-full login__button flex justify-center', showLoader ? 'opacity-70' : '']">
                    <div class="flex relative items-center">
                        {{ $__('login.password_reset_page.submit') }}
                        <Loader v-if="showLoader" height="19" width="19" class="absolute -right-6" />
                    </div>
                </Button>
            </div>
        </form>

        <a :href="route($page.props.locale + '.login')"
            :class="'mt-4 inline-block w-full text-center login__link cursor-pointer'">{{ $__('login.password_reset_page.return') }}</a>

        <FormResponseMessage/>
    </Guest>
</template>

<script>
import Guest from '@/Layouts/Guest';
import InputGroupFull from '@/Components/Form/InputGroupFull';
import Password from '@/Components/Form/Password';
import Button from '@/Components/Form/Button';
import FormResponseMessage from '@/Components/Form/ResponseMessage';
import Loader from '@/Components/Icons/Loader';
import {useForm} from "@inertiajs/inertia-vue3";

export default {
    components: { Button, Password, InputGroupFull, Guest, FormResponseMessage, useForm, Loader },
    data: () => ({
        form: useForm( {
            email: null
        } ),
        showLoader: false,
    }),
    methods: {
        submit() {
            this.form.post(route(this.$page.props.locale + '.password.send-reset'), {
                onStart: () => {
                    this.showLoader = true;
                },
                onFinish: () => {
                    this.showLoader = false;
                },
            });
        },
    },
    computed: {
        error() {
            return this.$page.props.error;
        },
    }
};
</script>
